import { render, staticRenderFns } from "./LanguagesList.vue?vue&type=template&id=92f6387a&scoped=true&"
import script from "./LanguagesList.vue?vue&type=script&lang=js&"
export * from "./LanguagesList.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesList.vue?vue&type=style&index=0&id=92f6387a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f6387a",
  null
  
)

export default component.exports